











































import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';
import AxSearchbar from './components/AxSearchbar/AxSearchbar.vue';
import PowerbarNav from './components/PowerbarNav/PowerbarNav.vue';
import AxSidebar from './components/AxSidebar/AxSidebar.vue';
import SettingsPanel from './components/SettingsPanel/SettingsPanel.vue';
import WhatsNewPanel from './components/WhatsNewPanel/WhatsNewPanel.vue';
import HelpPanel from './components/HelpPanel/HelpPanel.vue';

import { FundSearchState, FundHistoryState, NavigationState } from './store';
import { namespace } from 'vuex-class';
import validateEmail from '@/lib/validate-email';
const fundSearchState = namespace(FundSearchState.name);
const fundHistoryState = namespace(FundHistoryState.name);
const navigationState = namespace(NavigationState.name);

@Component({
    name:"AxPowerbar",
    components: {
        AxSearchbar,
        PowerbarNav,
        AxSidebar,
        SettingsPanel,
        WhatsNewPanel,
        HelpPanel
    },
})
export default class AxPowerbar extends Vue {
  @Prop({ required: true  }) public navData: any;
  @Prop({ required: false }) public eventsData: any;
  @Prop({ required: false }) public scopeData: any;
  @Prop({ required: false }) public username: string;
  @Prop({ required: false }) public enableDapSso: string;
  @Prop({ required: false }) public baseUrl: string;
  @Prop({ required: false }) public homeUrl: string;
  @Prop({ required: false }) public accessToken: string;
  @Prop({ required: false }) public fundSearchApiEndpoint: string;
  @Prop({ required: false }) public clientViewPath: string;
  @Prop({ required: false }) public classAgent: any;
  @Prop({ required: false }) public integrationConfig: any;
  @Prop({ required: false }) public entityChipData: any;
  @Prop({ required: false }) public enableHelpPanel: any;

  @fundSearchState.Mutation setAccessToken: (text: string) => void;
  @fundSearchState.Mutation setFundSearchApiEndpoint: (text: string) => void;
  @fundSearchState.Mutation setBusinessCode: (text: string) => void;
  @fundSearchState.Mutation setCacheSuffix: (text: string) => void;
  @navigationState.Mutation setNavData: (navData: any) => void;
  @navigationState.Mutation setEventsData: (eventData: any) => void;
  @fundSearchState.Action setupClassCommon: () => void;
  @fundSearchState.Action unsetClassCommon: () => void;
  @fundHistoryState.Mutation('setBusinessCode') setHistoryBusinessCode: (text: string) => void;

  @Watch('accessToken') onAccessTokenChange(val: string) { this.setAccessToken(val); }
  @Watch('username') onUsernameChange(val: string) {
    if (val === 'dev') {
      // exception for dev user.
      this.setCacheSuffix(val);
    } else if (!val || !validateEmail(val)) {
      this.setCacheSuffix('');
    } else {
      // cache for email usernames only
      this.setCacheSuffix(val);
    }
  }
  @Watch('fundSearchApiEndpoint') onfundSearchApiEndpoint(val: string) {
    this.updateFundSearchApiEndpointAndBusinessCode(val, this.homeUrl);
  }
  @Watch('homeUrl') onHomeUrlChanged(val: string) {
    this.updateFundSearchApiEndpointAndBusinessCode(this.fundSearchApiEndpoint, val);
  }

  private updateFundSearchApiEndpointAndBusinessCode(endpointBase: string, homeUrl: string) {
    const urlObj = new URL(homeUrl, 'https://app.class.com.au');
    const homePath = urlObj.pathname;
    const rx = new RegExp('^\/b\/(?<code>[a-zA-Z0-9\-_]*)\/.*');
    const businessCode = homePath.match(rx)?.groups?.code || '';
    const newUrl = `${endpointBase}/b/${businessCode}/search/entities`;
    this.setFundSearchApiEndpoint(newUrl);
    this.setBusinessCode(businessCode);
    this.setHistoryBusinessCode(businessCode);
  }
  @Watch('navData') onNavDataChange(val: any) { this.setNavData(val); }
  @Watch('eventsData') onEventsDataChange(val: any) { this.setEventsData(val); }

  @Emit('newFeatureToggled') public toggled(e: any) { return e; }
  @Emit('searchBoxFocused')  public searchBoxFocused(e: any) { return e; }

  @Emit('onPowerbarMouseUp') private onPowerbarMouseUp(e: Event) {
    return e;
  }

  public get additionalStyle() {
    const retval: any = {};
    try {
      const url = new URL(location.href);
      if (url.pathname.startsWith('/cm/') || url.pathname.startsWith('/dms/')) {
        retval['z-index'] = '1000';
      }
    } catch {

    }
    return retval;
  }

  public beforeCreate() {
    FundSearchState.register?.(this.$store);
    FundHistoryState.register?.(this.$store);
    NavigationState.register?.(this.$store);
  }

  @Emit('navigate') public navigate(e: Event) { return e; }

  public destroyed() {
    this.unsetClassCommon();
    FundSearchState.unregister?.(this.$store);
    FundHistoryState.unregister?.(this.$store);
    NavigationState.unregister?.(this.$store);
  }

  public mounted() {
    this.setupClassCommon();
    this.setAccessToken(this.accessToken);
    this.setFundSearchApiEndpoint(this.fundSearchApiEndpoint);
    this.setNavData(this.navData);
    this.setEventsData(this.eventsData);
    this.updateFundSearchApiEndpointAndBusinessCode(this.fundSearchApiEndpoint, this.homeUrl);
  }
}
